import { css, styled } from 'styled-components';
import { Col, Row } from 'antd';
import { StatusColProps, CurrentProps } from './types';
import { BLACK, PRIMARY_GRADIENT, WHITE } from 'styles/colors';

const AvatarPlaceholder = styled.div`
  // width: 7.5rem;
  // height: 7.5rem;
  // margin: 1rem;
  // background-color: rgba(255, 255, 255, 0.25);
  // border-radius: 1rem;
`;
// .withConfig({
//   shouldForwardProp: (prop) => !['color'].includes(prop),
// })<TeamColorProps>`
//   width: 2rem;


// `;
const Current = styled('div').withConfig({
  shouldForwardProp: (prop) => !['size'].includes(prop),
})<CurrentProps>`
  background: ${PRIMARY_GRADIENT};
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: ${WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0.5rem 0;
  width: 4.5rem;
  ${(props) => css`
  font-size: ${props.size || 1 * 1}rem;
  `}
`;

const GameRow = styled(Row)`
  height: calc(100% - 3.5rem);
  background-color: rgba(255, 255, 255, 1);
`;

const Next = styled.div`
  background-color: ${BLACK};
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: ${WHITE};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0.5rem 0;
  width: 4.5rem;
`;

const NicknameWrapper = styled(Col)`
  width: calc(100% - 12rem);
`;

const RaceGameCol = styled(Col)`
  width: 9.75rem;
`;

const RaceNumberWrapper = styled(Row)`
  background-color: rgba(0, 0, 0, 1);
  height: 3.5rem;
`;

const RunRow = styled(Row)`
  height: 9.5rem;
  background-color: rgba(0, 0, 0, 1);
`;

const RunRowsWrapper = styled(Col)`
  width: calc(100% - 9.75rem);
  gap: 0.063rem;
`;

const StatusCol = styled(Col).withConfig({
  shouldForwardProp: (prop) => !['background'].includes(prop),
})<StatusColProps>`
  width: 9.75rem;

  ${(props) => css`
    background: ${props.background};
  `}
`;

const StatusRow = styled(Row)`
  height: 3.5rem;
`;

const Wrapper = styled.div`
  // width: 53.125rem;
`;

export {
  AvatarPlaceholder,
  Current,
  GameRow,
  Next,
  NicknameWrapper,
  RaceGameCol,
  RaceNumberWrapper,
  RunRow,
  RunRowsWrapper,
  StatusCol,
  StatusRow,
  Wrapper,
};
